
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class UtentiDelegatiGrid extends Serenity.EntityGrid<UtentiDelegatiRow, any> {
        protected getColumnsKey() { return UtentiDelegatiColumns.columnsKey; }
        protected getDialogType() { return UtentiDelegatiDialog; }
        protected getIdProperty() { return UtentiDelegatiRow.idProperty; }
        protected getInsertPermission() { return UtentiDelegatiRow.insertPermission; }
        protected getLocalTextPrefix() { return UtentiDelegatiRow.localTextPrefix; }
        protected getService() { return UtentiDelegatiService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "column-picker-button"), 1);

            // Remove Button
            //buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            // Remove Button
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "refresh-button"), 1);

            //
            return buttons;
        }

        // /////////////////////////////////
        addButtonClick() {
            //super.addButtonClick();

        //    this.createEntityDialog(this.getItemType(), dlg => {
        //        var dialog = dlg as AllegatiDialog;
        //        dialog.Entita = this.Entita;
        //        dialog.EntitaId = this.EntitaId;
        //        dialog.EntitaIdentifier = this.EntitaIdentifier;
        //        dialog.loadNewAndOpenDialog();
        //    });
        }
    }
}